import { AppBar, Toolbar, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/accio-finserv-logo-text-variant.png';
import MenuComponent, { MenuObject } from '../baseComponents/menuComponent';
import React, { useEffect, useState } from 'react';
import ResetPasswordModal from '../modals/resetPasswordModal';
import JWTTokenPayload from '../../interfaces/JWTTokenPayload';
import { decodedJWT, getOwnerType, getPasswordExpiryTimestamps, getPdbID, getReminderText, getUserName, getUserRole } from '../../utils/commonUtils';
import { useAppDispatch } from '../../store/hooks';
import { AppDispatch } from '../../store/store';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import clearReduxAndThunk from '../../store/thunks/clearReduxAndTokenThunk';
import RoleManagement from '../../security/roleManagement';

const styles = {
  appBar: {
    backgroundColor: '#2c3e50',
    padding: '10px 0'
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  image: {
    height: '64px'
  },
  menuContainer: {
    position: 'absolute',
    top: 10,
    bottom: 0,
    right: 30,
    display: 'flex',
    alignItems: 'center'
  },
  portfolioText: {
    fontWeight: 'bold',
    mr: 2,
    mt: -0.5
  }
};

function Header() {
  const navigate = useNavigate();
  const token: JWTTokenPayload|false  = decodedJWT();
  const ownerType = getOwnerType(token);
  const username = getUserName(token);
  const pdbID = getPdbID(token);
  const userRole = getUserRole(token);
  const [passwordModalVisible, setPasswordModalVisible] = useState<boolean>(false);
  const [isPasswordResetMandatory, setIsPasswordResetMandatory] = useState<boolean>(false);
  const { headerMenuDisabled } = useSelector((state: RootState) => state.componentDisable);
  const dispatch: AppDispatch = useAppDispatch();

  const logout = () => {
    dispatch(clearReduxAndThunk(true));
    navigate('/login');
  };

  const switchPortfolio = () => {
    dispatch(clearReduxAndThunk(false));
    navigate('/portfolio');
  };

  useEffect(() => {
    const { passwordExpiryDate, passwordExpiryReminderDate } = getPasswordExpiryTimestamps(token);
    const currentDate = new Date();
    if (currentDate >= passwordExpiryReminderDate && currentDate < passwordExpiryDate) {
      const passwordReminderExpiryDuration = (new Date(passwordExpiryDate.getTime() - currentDate.getTime())).getTime();
      alert(getReminderText(passwordReminderExpiryDuration));
    } else if (currentDate >= passwordExpiryDate) {
      setIsPasswordResetMandatory(true);
      setPasswordModalVisible(true);
    }
  }, []);

  const menuOptions: MenuObject[] = [
    {
      text: `${username}`,
      onPress: () => {},
      showToUser: true,
    },
    {
      text: `${userRole}`,
      onPress: () => {},
      showToUser: true,
      dividerNext: true
    },
    {
      text: 'Switch Portfolio',
      onPress: switchPortfolio,
      showToUser: RoleManagement.isAgency(ownerType)
    },
    {
      text: 'Reset Password',
      onPress: () => setPasswordModalVisible(true),
      showToUser: true,
    },
    {
      text: 'Logout',
      onPress: logout,
      dividerNext: false,
      showToUser: true,
    },
  ];
  
  return (
    <AppBar position="static" sx={styles.appBar}>
      <Toolbar>
        <Box sx={styles.imageContainer}>
          <img
            src={logo}
            alt="Logo"
            style={styles.image}
          />
        </Box>
        <Box sx={styles.menuContainer}>
          {pdbID && (
            <Typography sx={styles.portfolioText}>Portfolio: {pdbID}</Typography>
          )}
          <MenuComponent disabled={headerMenuDisabled} options={menuOptions} />
        </Box>
      </Toolbar>
      <ResetPasswordModal
        openModal={passwordModalVisible}
        username={username || ''}
        handleCloseModal={() => setPasswordModalVisible(false)}
        isNonDismissable={isPasswordResetMandatory}
      />
    </AppBar>
  );
}

export default Header;
